import type { PipelineStage } from '../../store/types.ts';
import { STAGE_FLOW, STAGE_LABELS } from '../../store/types.ts';

type PipelineStepperProps = {
  pipelineStage: PipelineStage;
};

function stageStepState(
  step: (typeof STAGE_FLOW)[number],
  pipelineStage: PipelineStage,
): 'done' | 'active' | 'pending' {
  const currentIndex = STAGE_FLOW.indexOf(pipelineStage as (typeof STAGE_FLOW)[number]);
  const stepIndex = STAGE_FLOW.indexOf(step);
  if (pipelineStage === 'completed') return 'done';
  if (pipelineStage === 'error' || pipelineStage === 'cancelled' || pipelineStage === 'idle') return 'pending';
  if (stepIndex < currentIndex) return 'done';
  if (stepIndex === currentIndex) return 'active';
  return 'pending';
}

export function PipelineStepper({ pipelineStage }: PipelineStepperProps) {
  if (pipelineStage === 'idle') return null;

  return (
    <div className="ds-pipeline" aria-label="AI generation progress">
      {STAGE_FLOW.map((step) => {
        const state = stageStepState(step, pipelineStage);
        return (
          <div key={step} className={`ds-pipeline__step ds-pipeline__step--${state}`}>
            <span className="ds-pipeline__dot" aria-hidden="true" />
            <span>{STAGE_LABELS[step]}</span>
          </div>
        );
      })}
    </div>
  );
}
